<template>
  <div>
    <div class="employee-card">
      <div class="d-flex align-items-start justify-content-between">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <img class="profile-img" :src="employee.profileImg" v-if="employee.profileImg" alt="employee image" />
            <img
              class="profile-img"
              v-else
              :src="`https://avatars.dicebear.com/api/initials/${employee.name}.svg`"
              alt="employee image"
            />
          </div>
          <div class="ms-2">
            <div class="d-flex align-items-center">
              <p class="employee-title">{{ employee.name }}</p>
              <!-- <Badge
                  :label="employee.experience + ` Years`"
                  class="badge-neon badge-neon-success-outline ms-2 text-uppercase px-2 py-0"
                /> -->
            </div>
            <p class="employee-subtitle">{{ structureDesignation(employee.designation) }} - {{ employee.team.name ? employee.team.name : 'No Team Assigned' }}</p>
          </div>
        </div>
        <div>
          <p class="employee-subtitle">{{ employee.emailId }}</p>
          <!-- <Badge
                  :label="employee.experience + ` Years`"
                  class="badge-neon badge-neon-success-outline ms-2 text-uppercase px-2 py-0"
                /> -->
          <p class="employee-subtitle ms-auto fw-bold">{{ employee.location.city }}</p>
        </div>

        <!-- <Button
          class="qb-btn qb-btn-outline-sm py-1 px-2"
          data-bs-toggle="collapse"
          :data-bs-target="'#collapse' + employee.id"
          ><font-awesome-icon icon="fa-solid fa-angle-down"
        /></Button> -->
      </div>
    </div>

    <!-- <div class="collapse mb-2" :id="'collapse' + employee.id">
      <div class="p-2">
        <div class="card-box" @click="toggleEvaluationModal()">
          <Card v-for="(data, index) in 5" :key="index" class="module-card">
            <div class="d-flex justify-content-between">
              <div class="p-3">
                <p class="worksheet-title">Training {{ index + 1 }}</p>
                <p class="reporter-label">Reporter:</p>
                <p class="reporter-title">Ashok</p>
              </div>
              <div class="chart-area">
                <ApexChart :options="chartOptions" :series="[20]" />
              </div>
            </div>
            <div class="start-date-badge my-2">
              <Badge
                :label="`Start Date: ` + formatDate(employee.dateOfJoin)"
                class="badge-rounded badge-rounded-grey-outline ms-2"
              />
            </div>
          </Card>
        </div>
      </div>
    </div> -->

    <!-- <Modal @close="toggleEvaluationModal" :modalActive="showEvaluationModal">
      <div class="d-flex">
        <h4 class="modal-heading flex-fill">Training 1</h4>
        <Badge label="12/15 Completed" class="badge-neon badge-neon-warning-outline float-end" />
      </div>
      <hr class="mb-2 m-0 p-0" />
      <div>
        <div v-for="(task, index) in tasks" :key="index">
          <Card data-bs-toggle="collapse" :data-bs-target="'#collapse' + index" class="p-2 mb-2 m-1 employee-card"
            >{{ task.name }}
            <Badge
              :label="task.status ? 'Completed' : 'Not submitted'"
              :class="[
                'badge-rounded float-end',
                { 'badge-neon-success-outline': task.status },
                { 'badge-neon-error-outline': !task.status },
              ]"
            />
          </Card>
          <div class="collapse p-2 m-1 mb-2 submission" :id="'collapse' + index">
            <p class="sub-heading my-0">Link :</p>
            <a target="_blank" href="https://www.google.com">{{ task.submission }} </a>
            <p class="sub-heading my-0 mt-1">Comments :</p>
            <p class="mb-0">comments added by user</p>
            <p>
              <Badge
                :label="'Start Date : ' + task.startDate"
                class="badge-rounded badge-rounded-grey-outline float-start"
              ></Badge>
              <Badge
                :label="'Completed Date : ' + task.completedDate"
                class="badge-rounded badge-rounded-grey-outline float-end"
              ></Badge>
            </p>
          </div>
        </div>
      </div>
    </Modal> -->
  </div>
</template>

<script>
// import EvaluationModal from "../components/EvaluationModal.vue"
// import Modal from "../components/ModalComponent.vue";
// import Badge from "../components/BadgeComponent.vue";
// import Button from "../components/ButtonComponent.vue";
// import Card from "../components/CardComponent.vue";
// import { createNamespacedHelpers } from "vuex";
// const { mapActions: mapUserActions, mapGetters } =
//   createNamespacedHelpers("User");
// // const { mapGetters: mapAuthGetters } = createNamespacedHelpers("Auth");
export default {
  name: "EmployeeListComponent",
  data() {
    return {
      chartOptions: {
        chart: {
          height: 10,
          width: 10,
          type: "radialBar",
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: 0,
            endAngle: 360,
            hollow: {
              margin: 0,
              size: "70%",
              background: "#ffffff",
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: "front",
            },
            track: {
              background: "#f3f3f3",
              strokeWidth: "80%",
              margin: 0,
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -5,
                show: true,
                color: "#888",
                fontSize: "10px",
              },
              value: {
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: 3,
                color: "#000",
                fontSize: "12px",
                show: true,
              },
            },
          },
        },
        fill: {
          type: ["solid"],
          colors: ["#1da8d5"],
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["Progress"],
        fontSize: "10px",
      },
      showEvaluationModal: false,
      tasks: [
        {
          name: "Task 1",
          status: true,
          submission: "github link",
          startDate: "8 Nov 2022",
          completedDate: "10 Nov 2022",
        },
        {
          name: "Task 2",
          satus: true,
          submission: "github link",
          startDate: "8 Nov 2022",
          completedDate: "10 Nov 2022",
        },
      ],
    };
  },
  props: {
    employee: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    // Badge,
    // Button,
    // Card,
    // Modal,
    // EvaluationModal
  },
  methods: {
    // ...mapUserActions({
    //   getallworksheet: "GET_ALL_WORKSHEET",
    // }),
    structureDesignation(designation) {
      return designation.split("_").join(" ");
    },
    toggleEvaluationModal() {
      this.showEvaluationModal = !this.showEvaluationModal;
    },
  },
  // computed:{
  //    ...mapGetters({
  //     worksheets: "getAllWorkSheet",
  //   }),
  // },
  // mounted(){
  //    this.getallworksheet(this.employee.id);
  // }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.card-box {
  padding: 0px 10px 10px 10px;
  border-radius: $field-border-radius;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 10px;
}
.card-box:hover {
  cursor: pointer;
}

.chart-area {
  width: 150px;
  height: 100px;
}

.reporter-label {
  font-size: $font-size-sm;
  color: $badger-orange;
  font-weight: $font-weight-bold;
  margin: 0px;
}

.reporter-title {
  font-size: $font-size-sm;
  color: $light-500;
  font-weight: $font-weight-bold;
  margin: 0px;
}

.card-box::-webkit-scrollbar {
  background: none;
  height: 5px;
}

.card-box::-webkit-scrollbar-thumb {
  background-color: $border-color;
  border-radius: $field-border-radius;
}

.module-card {
  min-width: 300px;
}

.worksheet-title {
  font-weight: 600;
  font-size: 14px;
  margin: 0px;
  margin-bottom: 5px;
}

.profile-img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.employee-card {
  background-color: $white;
  padding: 8px 12px;
  border-radius: $field-border-radius;
  margin-bottom: 10px;
  border: 1px solid $light-200;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

  // &:hover {
  //   background-color: $light-fade-200;
  //   cursor: pointer;
  // }
}

.employee-title {
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin-bottom: 0px;
}

.employee-subtitle {
  font-size: $font-size-sm;
  color: $light-600;
  // font-weight: $font-weight-normal-1;
  margin-bottom: 0px;
  width: fit-content;
}

.task-count {
  min-width: fit-content;
}

.modal-heading {
  font-size: $font-size-xxl;
  font-weight: 600;
}
.sub-heading {
  font-size: $font-size-md;
  font-weight: 600;
}
.submission {
  border: 1px solid $light-200;
  border-radius: $field-border-radius;
}
</style>
